<template>
	<el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :before-close="handleClose" append-to-body>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="学校名称" prop="name">
				<el-input v-model="ruleForm.name" @input="inputSchool()"></el-input>
			</el-form-item>
			<el-form-item label="首字母" prop="firstLetter">
				<el-input v-model="ruleForm.firstLetter" :disabled="true"></el-input>
			</el-form-item>
			<el-form-item label="学校logo" prop="logo">
				<vue-cropper2 @upfile="upicon" :defaultIcon="setIcon(ruleForm.logo)" :width="300" :height="80"
					style="margin-left: 14px;" path="SchoolLogo">
				</vue-cropper2>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="submitForm('ruleForm')">立即{{type==='add'?'添加':'修改'}}</el-button>
			<el-button @click="resetForm('ruleForm')">重置</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import pinyin from '../../../../public/js/Convert_Pinyin.js'
	import vueCropper2 from '@/components/vue-cropper2'

	export default {
		name: 'schoolEdit',
		props: {
			type: {
				type: String,
				default: 'add'
			},
			title: {
				type: String
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
			obj: {
				type: Object,
				default: null
			},
			SchoolArray: {
				type: Array,
				default: null
			}
		},
		data() {
			return {
				ruleForm: {
					id: '',
					name: '',
					firstLetter: '',
					logo: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入学校名称',
						trigger: 'blur'
					}],
					authCode: [{
						required: true,
						message: '请填写授权码',
						trigger: 'change'
					}],
					authCount: [{
						type: 'number',
						message: '授权节点必须为数值'
					}]
				}
			}
		},
		components: {
			vueCropper2
		},
		watch: {
			obj(val) {
				this.ruleForm = JSON.parse(JSON.stringify(val))
			}
		},
		methods: {
			setIcon(logo) {
				if (logo.indexOf('http') > -1) {
					return logo
				} else if (logo != '') {
					return this.$http.fileUrl + logo
				}
			},
			upicon(e) {
				this.ruleForm.logo = e;
			},
			inputSchool() {
				let e = pinyin.getFullChars(this.ruleForm.name).match(/[A-Z]/g)
				if (e != null)
					this.ruleForm.firstLetter = e.join('')
				else
					this.ruleForm.firstLetter = ''
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {

						if (this.ruleForm.logo.indexOf('http') != -1) {
							this.ruleForm.logo = this.ruleForm.logo.replace(this.$http.fileUrl, '')
						}

						this.type === 'add' && this.$http.post('api/Org/SaveSchool', this.ruleForm).then(res => {
							this.handleClose()
						})

						this.type === 'update' && this.$http.post('api/Org/EditSchool', this.ruleForm).then(
							res => {
								this.handleClose()
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleClose() {
				this.$emit('before-close')
			}
		}
	}
</script>

<style>
</style>
